import React from 'react';

const DoubleArrow = ({ color = '#fff' }) => {
  return (
    <svg width="10.954" height="10.415" viewBox="0 0 10.954 10.415">
      <g id="Group_2976" data-name="Group 2976" transform="translate(-243 -485)">
        <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M13.045,11.4l3.941-3.937a.744.744,0,0,0-1.054-1.051l-4.465,4.461a.743.743,0,0,0-.022,1.026l4.483,4.492a.744.744,0,0,0,1.054-1.051Z" transform="translate(260.205 501.608) rotate(180)" fill={color} />
        <path id="Icon_ionic-ios-arrow-back-2" data-name="Icon ionic-ios-arrow-back" d="M13.045,11.4l3.941-3.937a.744.744,0,0,0-1.054-1.051l-4.465,4.461a.743.743,0,0,0-.022,1.026l4.483,4.492a.744.744,0,0,0,1.054-1.051Z" transform="translate(265.205 501.608) rotate(180)" fill={color} />
      </g>
    </svg>
  );
}

export default DoubleArrow;